import React, { useState, useEffect } from 'react';
import { TextField, Button, Grid, Typography, FormControl, InputLabel, Select, MenuItem } from '@mui/material';

function NuevaCategoriaIngrediente({ onCategoriaIngredienteCreated }) {
  const [categoriaIngrediente, setCategoriaIngrediente] = useState({ name: '', description: '', parent: '' });
  const [categorias, setCategorias] = useState([]);

  useEffect(() => {
    fetch(`${import.meta.env.VITE_API_URL}/ingredient-categories`)
      .then(response => response.json())
      .then(data => setCategorias(data))
      .catch(error => console.error('Error:', error));
  }, []);

  const handleChange = (event) => {
    setCategoriaIngrediente({ ...categoriaIngrediente, [event.target.name]: event.target.value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const dataToSend = {
      ...categoriaIngrediente,
      parent: categoriaIngrediente.parent || null
    };
    fetch(`${import.meta.env.VITE_API_URL}/ingredient-categories`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(dataToSend),
    })
      .then(response => response.json())
      .then(() => {
        onCategoriaIngredienteCreated();
        setCategoriaIngrediente({ name: '', description: '', parent: '' });
      })
      .catch(error => console.error('Error:', error));
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h4">Nueva Categoría de Ingrediente</Typography>
      </Grid>
      <Grid item xs={12}>
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Nombre"
            name="name"
            value={categoriaIngrediente.name}
            onChange={handleChange}
            margin="normal"
            required
          />
          <TextField
            fullWidth
            label="Descripción"
            name="description"
            value={categoriaIngrediente.description}
            onChange={handleChange}
            margin="normal"
            multiline
            rows={4}
          />
          <FormControl fullWidth margin="normal">
            <InputLabel>Categoría Padre</InputLabel>
            <Select
              name="parent"
              value={categoriaIngrediente.parent}
              onChange={handleChange}
            >
              <MenuItem value="">
                <em>Ninguna</em>
              </MenuItem>
              {categorias.map((categoria) => (
                <MenuItem key={categoria._id} value={categoria._id}>
                  {categoria.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button type="submit" variant="contained" color="primary">
            Crear Categoría de Ingrediente
          </Button>
        </form>
      </Grid>
    </Grid>
  );
}

export default NuevaCategoriaIngrediente;